import { EditMode } from "PFApp/booking/types/edit_mode";
import { RequirementType } from "PFTypes";

import {
  BulkAction,
  BulkDatesMode,
  SelectModeSlice,
  SmartPlannerModeSlice,
  SplitModeSlice,
  WallPlannerModeSlice
} from "./booking_edit_mode_store.types";

export const MAX_EVENT_HISTORY = 100;

export const INITIAL_SELECT_MODE_STATE: SelectModeSlice = {
  totalSelection: null,
  isSelectAllMode: false,

  valuesToUpdate: {
    bulkAction: BulkAction.BulkUpdateDates,
    dates: {
      mode: BulkDatesMode.BulkMove,
      date: ""
    },
    details: {
      bookingCategoryId: {
        enabled: false,
        value: { category: null, updateBookingsTitles: false }
      },
      title: {
        enabled: false,
        value: ""
      },
      description: {
        enabled: false,
        value: ""
      }
    },
    duration: {
      durationType: RequirementType.Load,
      durationValue: null
    }
  },

  bookingsCount: undefined,
  bookingsRangeMinDate: null,
  bookingsRangeMaxDate: null,
  selectableBookingIds: [],
  filteredBookings: [],
  filteredBookingsCategoriesIds: [],

  isLoading: false,
  isSubmitting: false,

  events: [],
  selection: null,
  selectedRows: []
};

export const getInitialSplitModeState = (): SplitModeSlice => ({
  bookingIds: new Set(),
  operationsHistory: [],
  isLoading: false,
  isSubmitting: false
});

export const INITIAL_WALL_PLANNER_MODE_STATE: WallPlannerModeSlice = {
  updatableBookingIds: [],
  isLoading: false,
  focusedInputId: null
};

export const INITIAL_SMART_PLANNER_MODE_STATE: SmartPlannerModeSlice = {
  editingCell: null,
  updatableBookingIds: [],
  isLoading: false,
  pendingEdits: {}
};

export const INITIAL_EDIT_MODE = EditMode.Disabled;
